import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { selectAllText } from "../../Utils/Common";
import SmallIcon from "../Icons/SmallIcon/SmallIcon";
function InputEditable(props) {
  const [value, setvalue] = useState("");
  const [changeTitle, setChangeTitle] = useState(false);
  const [selectText, setSelectText] = useState(false);
  const [t, i18n] = useTranslation("common");
  let defaultTitle = t(`${props.sectionId}.defaultTitle`);
  if (defaultTitle.includes("customText")) {
    defaultTitle = "Custom Text Section";
  } else if (defaultTitle.includes("customDate")) {
    defaultTitle = "Custom Date Section";
  }
  const inputRef = useRef();
  useEffect(() => {
    if (props && props.resumeFields && props.resumeFields.customTitle) {
      setvalue(props && props.resumeFields && props.resumeFields.customTitle);
    } else if (
      props &&
      props.resumeFields &&
      props.resumeFields[props.indexArray] &&
      props.resumeFields[props.indexArray]["customTitle"]
    ) {
      setvalue(
        props &&
          props.resumeFields &&
          props.resumeFields[props.indexArray] &&
          props.resumeFields[props.indexArray]["customTitle"]
      );
    } else {
      setvalue(defaultTitle);
    }
  }, [props]);

  const handleInputEditable = () => {
    setChangeTitle(!changeTitle);
  };

  const handleFocus = (event) => {
    if (selectText) {
      selectAllText(event);
      setSelectText(false);
    }
  };

  useEffect(() => {
    if (changeTitle) {
      inputRef.current.focus();
    }
  }, [changeTitle]);

  return (
    <>
      <div className="d-flex input-editable-section">
        <div
          className="input-editable-focus"
          contentEditable={true}
          suppressContentEditableWarning={true}
          ref={inputRef}
          name={props && props.name}
          onBlur={(e) => {
            props.onBlur(e, props.indexArray, "visual", props.sectionId);
            handleInputEditable();
            setvalue(`${e.target.innerText.trim()} `);
          }}
          data-placeholder={defaultTitle}
          onClick={() => handleInputEditable()}
          onFocus={handleFocus}
          dangerouslySetInnerHTML={{ __html: value }}
        />
        <div
          className="d-none cursor-pointer "
          onClick={() => {
            setSelectText(true);
            handleInputEditable();
          }}
          style={{ marginTop: "-1px" }}
        >
          <SmallIcon margin src="/images/edit-pencil.png" />
        </div>
        {props && props.resumeFields && props.resumeFields.customTitle != "" ? (
          <div
            className="d-none cursor-pointer ml-1"
            name={props && props.name}
            onClick={(e) => {
              props.onRemove(e, props.indexArray, "visual", props.sectionId);
            }}
          >
            <i
              name={props && props.name}
              className="fa fa-undo"
              style={{ color: "#ced4da" }}
            ></i>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default InputEditable;
